import { AuditTrailServiceApiAuditTrailServiceResourceActionsMonthlyRequest } from '@ariksa/audittrail/api';
import {
  ItemApiApproveRequestRequest,
  ItemApiListAllRequestsRequest,
  ItemApiListMyRequestsRequest,
  PageAccessRequestGetResponse,
} from '@ariksa/jit';
import {
  ItemApiDenyRequestRequest,
  ItemApiGetAssumeRolePolicyRequest,
  ResponseDenyRequestV1JitRequestsDenyRequestIdPost,
} from '@ariksa/jit/api';
import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import {
  AuditTrailApiService,
  authTokenHeader,
  JitService,
} from 'api/services';

import { actions } from './slice';

export function* jitRequestsSaga() {
  yield takeLatestAction(actions.getJitRequests, doGetJitRequests);
  yield takeLatestAction(actions.getMyRequests, doGetMyRequests);
  yield takeLatestAction(
    actions.getResourceActionPerHour,
    doGetResourceActionsPerHour,
  );
  yield takeLatestAction(
    actions.getResourceActionOnDay,
    doGetResourceActionsOnDay,
  );
  yield takeLatestAction(actions.approveJitRequest, doApproveJitRequest);
  yield takeLatestAction(actions.denyJitRequest, doDenyJitRequest);
  yield takeLatestAction(actions.getPolicyDocument, doGetPolicyDocument);
}

function* doGetJitRequests(
  ctx: QueryContext<
    PageAccessRequestGetResponse,
    ItemApiListAllRequestsRequest
  >,
) {
  yield call(ctx.fetch, () => JitService.Jit.listAllRequests(ctx.params));
}

function* doGetMyRequests(
  ctx: QueryContext<PageAccessRequestGetResponse, ItemApiListMyRequestsRequest>,
) {
  yield call(ctx.fetch, () => JitService.Jit.listMyRequests(ctx.params));
}

export function* doGetResourceActionsPerHour(
  ctx: QueryContext<
    any,
    AuditTrailServiceApiAuditTrailServiceResourceActionsMonthlyRequest
  >,
) {
  yield ctx.fetch(() =>
    AuditTrailApiService.AuditTrail.auditTrailServiceResourceActionsMonthly(
      ctx.params,
      authTokenHeader(),
    ),
  );
}

export function* doGetResourceActionsOnDay(ctx: QueryContext<any, any>) {
  yield ctx.fetch(() =>
    AuditTrailApiService.AuditTrail.auditTrailServiceResourceActionsDaily(
      ctx.params,
      authTokenHeader(),
    ),
  );
}

export function* doApproveJitRequest(
  ctx: QueryContext<any, ItemApiApproveRequestRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.approveRequest(ctx.params));
}

export function* doDenyJitRequest(
  ctx: QueryContext<
    ResponseDenyRequestV1JitRequestsDenyRequestIdPost,
    ItemApiDenyRequestRequest
  >,
) {
  yield ctx.fetch(() => JitService.Jit.denyRequest(ctx.params), {});
}

export function* doGetPolicyDocument(
  ctx: QueryContext<any, ItemApiGetAssumeRolePolicyRequest>,
) {
  yield ctx.fetch(() => JitService.Jit.getAssumeRolePolicy(ctx.params));
}
